import { SolutionModelSubtype } from '@/constants/checkoutSolutionModel';
import type { CheckoutConfigurations } from '@/types/checkout';

export const getCheckoutSolution = (checkoutConfiguration: CheckoutConfigurations | undefined) => {
  if (!checkoutConfiguration) return { isPaymentLinks: false, isSideLoading: false, isWebCheckout: false };
  return {
    isPaymentLinks: checkoutConfiguration.solutionModelSubtype === SolutionModelSubtype.PAYMENT_LINKS,
    isSideLoading: checkoutConfiguration.solutionModelSubtype === SolutionModelSubtype.SIDE_LOADING,
    isWebCheckout: checkoutConfiguration.solutionModelSubtype === SolutionModelSubtype.WEB_CHECKOUT,
  };
};
